/* eslint-disable react/prop-types */

import { createContext, useState } from 'react';
import { ArtStatusErrorPopUp } from '../../components';
import { useNavigate } from 'react-router-dom';
import { UseCheckArtPending } from '../../hooks/useCheckArtPending';
import { useEffect } from 'react';
import { notifyErrorCustom } from '../../utils/notify';
import { ArtStatusService, OrchestratorImageGenerationService } from '../../services';
import { showArtPendingToast } from '../../components/SnackBar';


export const ArtPedingContext = createContext();

export const ArtPendingProvider = ({ children }) => {
  const [artStatus, setArtStatus] = useState()
  const [showSnackBar, setShowSnackBar] = useState(null)
  const [showRememberArtPendingPopUp, setShowRememberArtPendingPopUp] = useState(null)

  // const navigate  = useNavigate()

  // const handleNavigate = async (path, options) =>{
  //   await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
  //   setArtStatus(null)
  //   navigate(path, options)
  // }

  useEffect(() => {
    if (artStatus && !artStatus.isVisualized && artStatus.status === 'PENDING') {
      const interval = setInterval(async () => {
        await checkImageGenerationStatus(artStatus?.uuid)
      }, 10000);

      return () => clearInterval(interval);
    }

  }, [artStatus])

  useEffect(() => {
    if (showSnackBar && location.pathname.toLowerCase() !== '/newpublicationpageia' && location.pathname.toLowerCase() !== '/signin' && artStatus && artStatus.isVisualized === false) {
      showArtPendingToast()
      setShowSnackBar(false)
    }

  }, [location.pathname, artStatus, showSnackBar])

  const checkImageGenerationStatus = async (uuid) => {
    const response = await OrchestratorImageGenerationService.checkArtStatus(uuid)

    if (!response?.data?.isVisualized) {
      const data = response?.data
      if (data?.status === 'DONE' && data?.imageUrl) {
        const separator = data.imageUrl.includes('?') ? '&' : '?'
        data.imageUrl = `${data.imageUrl}${separator}t=${Date.now()}`
      }
      setArtStatus((prev) => ({ ...prev, ...data }))
    }

    if (!response?.data?.isVisualized && response.data.status === 'ERROR') {

      if (response.data.description === 'unsafe_prompt') {
        notifyErrorCustom('Erro ao gerar prompt: o prompt viola as políticas de privacidade')
      }


      if (response?.data?.isVisualized) setArtStatus((prev) => ({ ...prev, status: 'PENDING', imageUrl: '' }))
    }

  }


  return (
    <ArtPedingContext.Provider value={{ artStatus, setArtStatus, showSnackBar, setShowSnackBar, showRememberArtPendingPopUp, setShowRememberArtPendingPopUp }}>
      {children}
    </ArtPedingContext.Provider>
  );
}
